import { closeDeeplinkReadingPane } from 'owa-mail-actions/lib/readingPaneActions';
import { orchestrator } from 'satcheljs';

// This orchestrator is only for deeplink package which is used to
// close the deeplink window when some triage actions are completed.
export default orchestrator(closeDeeplinkReadingPane, () => {
    window.close();
});
